// src/utils/dateFormatter.js
import { format, startOfDay, isEqual, parseISO } from 'date-fns';

export const formatDateToDayString = (date) => {
  if (!date) return '';
  return format(date, 'yyyy-MM-dd');
};

export const formatTimeToHHMM = (date) => {
  if (!date) return '';
  return format(date, 'HH:mm');
};

export const isSameDay = (date1, date2) => {
  if (!date1 || !date2) return false;
  return isEqual(startOfDay(date1), startOfDay(date2));
};

export const parseDayString = (dateString) => {
  if (!dateString) return null;
  return parseISO(dateString); // Expects 'yyyy-MM-dd'
};

export const generateTimeLabelsForDay = () => {
  const labels = [];
  for (let h = 0; h < 24; h++) {
    labels.push(`${String(h).padStart(2, '0')}:00`);
  }
  return labels; // Array of 24 "HH:00" strings
};